import api from "api";

const producerProfiles = {
    create: (payload) => {
        return api().post('/producer-profiles', payload);
    },

    me: () => {
        return api().get('/producer-profiles/me');
    },

    getBySlug: (slug) => {
        return api().get(`/producer-profiles/detail/${slug}`);
    },

    update: (slug, payload) => {
        return api().put(`/producer-profiles/${slug}`, payload);
    },

    delete: (slug) => {
        return api().delete(`/producer-profiles/${slug}`);
    },

    getEvents: (slug, status, page = 1, perPage = 15) => {
        return api().get(`/producer-profiles/producer/${slug}/events`, {
            params: { status, page, per_page: perPage }
        });
    },

    getOptions: () => {
        return api().get('/producer-profiles/options');
    },

    getCustomers: (slug, params) => {
        return api().get(`/producer-profiles/${slug}/customers`, { params });
    },

    // Eventos/clientes do usuário logado, sem depender de um producer_profiles
    // existir — perfil de produtor é opcional, ter evento criado não é a
    // mesma coisa (conta de estabelecimento também vende como produtor).
    getMeEvents: (status, page = 1, perPage = 15) => {
        return api().get('/producer-profiles/me/events', {
            params: { status, page, per_page: perPage }
        });
    },

    getMeCustomers: (params) => {
        return api().get('/producer-profiles/me/customers', { params });
    },
};

export default producerProfiles;
